'use strict';

module.exports = {
  manual: 'MANUAL',
  auto: 'AUTO',
};
